import React, {useState, useRef, useEffect, useContext} from 'react';
import clsx from 'clsx';
import {
    makeStyles,
    AppBar,
    Badge,
    Button,
    IconButton,
    Toolbar,
    Hidden,
    colors,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {},
    flexGrow: {
        flexGrow: 1
    },
    logo: {
        width: 200,
    },
}));


const TopBar = ({className}) => {
    const classes = useStyles();
    return (
        <AppBar
            className={clsx(classes.root, className)}
            color="primary"
        >
            <Toolbar>
                <img
                    className={classes.logo}
                    alt="Logo"
                    src="/images/logo.png"/>
            </Toolbar>
        </AppBar>

    )
};

export default TopBar;
